import { StyledSubProduct } from './styles';

export const SubProduct = ({
  product = '',
  quantityDisplay = '',
  textFontColorHex = '#fff',
}: {
  product?: string;
  quantityDisplay?: string;
  textFontColorHex?: string;
}) => {
  return (
    <StyledSubProduct>
      <img className="image" src={product} alt="product" />
      <div style={{ color: textFontColorHex || '#fff' }} className="quantity">
        {quantityDisplay}
      </div>
    </StyledSubProduct>
  );
};
